const search = (function(){

    const getSearchInput = document.querySelector('.search-results__input');

    function _search(){
        if(getSearchInput){
            let getNextElementSibling = getSearchInput.nextElementSibling;
            function validateLenght(){

                let getValueInput = getSearchInput.value;
                getValueInput.length >= 1 ? getNextElementSibling.classList.add('active') : getNextElementSibling.classList.remove('active');
    
            }
    
            getNextElementSibling.addEventListener('click', ()=>{
                getSearchInput.value = "";
                validateLenght();
            });
            getSearchInput.addEventListener('keyup', validateLenght);
        }
    }

    return {
        setHandleEvent : function(){
            try{
                _search()
            }catch(error){ }
        }
    }

})();


const loadSearchHandlers = ()=>{
    search.setHandleEvent()
}


export {
    loadSearchHandlers
}